<template>
  <v-container class="admin-console" fluid>
    <v-card flat class="mb-4">
      <v-card-title class="px-4 py-3 d-flex align-center">
        <v-btn icon @click.stop="drawer = !drawer" class="mr-2" color="primary">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <h5 class="admin-title">Consola de administración CMDA</h5>
        <v-spacer></v-spacer>
        <notification-center class="mr-2"/>
        <v-badge bordered color="red" :content="packagePendingQuantity" overlap>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                class="white--text"
                color="primary"
                fab
                small
                @click="showPendingPackagesToAssignModal = true"
              >
                <v-icon>mdi-package</v-icon>
              </v-btn>
            </template>
            <span>Paquetes pendientes</span>
          </v-tooltip>
        </v-badge>
      </v-card-title>
    </v-card>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      floating
      :width="280"
      class="floating-menu"
      :style="{ top: $vuetify.breakpoint.mobile ? '64px' : '76px' }"
    >
      <v-list dense nav>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ getSelectedItemTitle }}
            </v-list-item-title>
            <v-list-item-subtitle>Menú</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list>
          <v-list-item
            v-for="(item, index) in availableMenuItems"
            :key="index"
            :class="{ highlighted: selectedItemKey === item.key }"
            @click="selectItem(item.key)"
            link
          >
            <v-list-item-icon>
              <v-icon
                :class="selectedItemKey === item.key ? 'custom-icon' : ''"
              >
                {{ item.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list>
    </v-navigation-drawer>
    <v-card rounded="lg" elevation="5" class="main-content-card">
      <v-container fluid class="pa-0 ma-0 fill-height">
        <v-row no-gutters class="fill-height">
          <v-col cols="12" class="content-col">
            <div class="content-wrapper">
              <component :is="currentComponent" v-if="currentComponent" />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <pending-packages-to-assign-modal
      v-model="showPendingPackagesToAssignModal"
      v-if="showPendingPackagesToAssignModal"
      @fetch_count="fetchPendingPackages"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LevelRiskTable from "@/components/cmda_admin/LevelRiskTable.vue";
import ResultTest from "@/components/cmda_admin/ResultTest.vue";
import ProductsTable from "@/components/cmda_admin/ProductsTable.vue";
import CMDAPanel from "@/components/cmda_admin/CMDAPanel.vue";
import MolecularMarkerTable from "@/components/cmda_admin/MolecularMarkerTable.vue";
import IdentificationsTable from "@/components/cmda_admin/IdentificationsTable.vue";
import Validation from "@/components/validations/Validation.vue";
import OligoHistoryTable from "@/components/validations/OligoHistoryTable.vue";
import MarkersCMDA from "../components/cmda_admin/MarkersCMDA.vue";
import NotificationCenter from "../components/cmda_admin/NotificationCenter.vue";
import PendingPackagesToAssignModal from "../components/cmda_admin/modals/PendingPackagesToAssignModal.vue";
export default {
  name: "AdminConsole",
  components: {
    LevelRiskTable,
    ResultTest,
    ProductsTable,
    CMDAPanel,
    MolecularMarkerTable,
    IdentificationsTable,
    Validation,
    OligoHistoryTable,
    MarkersCMDA,
    NotificationCenter,
    PendingPackagesToAssignModal,
  },
  data: () => ({
    selectedItemKey: null,
    drawer: false,
    menuItems: [
      {
        key: "management",
        title: "Gestion CMDA",
        icon: "mdi-cog",
        permission: "console_cmda_management",
        component: "CMDAPanel",
      },
      {
        key: "markers",
        title: "Marcadores",
        icon: "mdi-sign-text",
        permission: "console_cmda_molecular_markers",
        component: "MarkersCMDA",
      },
      {
        key: "levels",
        title: "Niveles",
        icon: "mdi-chart-timeline-variant",
        permission: "console_cmda_risk_levels",
        component: "LevelRiskTable",
      },
      {
        key: "test",
        title: "Test",
        icon: "mdi-auto-fix",
        permission: "console_cmda_test",
        component: "ResultTest",
      },
      {
        key: "products",
        title: "Productos (Prescripción)",
        icon: "mdi-basket-outline",
        permission: "console_cmda_prescriptions",
        component: "ProductsTable",
      },
      {
        key: "identifications",
        title: "Identificaciones",
        icon: "mdi-bacteria",
        permission: "console_cmda_identifications",
        component: "IdentificationsTable",
      },
    ],
    hideMainTable: false,
    showValidations: false,
    showOligoHistory: false,
    isSetup: false,
    notifications: [],
    packagePendingQuantity: 0,
    showPendingPackagesToAssignModal: false,
  }),
  computed: {
    ...mapState("session", ["permissions"]),
    availableMenuItems() {
      return this.menuItems.filter((item) =>
        this.hasPermission(item.permission)
      );
    },
    getSelectedItemTitle() {
      const item =
        this.menuItems.find((item) => item.key === this.selectedItemKey) ||
        this.availableMenuItems[0];
      return item ? item.title : "No tienes permisos";
    },
    currentComponent() {
      if (!this.selectedItemKey) return null;
      const item = this.menuItems.find(
        (item) => item.key === this.selectedItemKey
      );
      return item ? item.component : null;
    },
  },
  methods: {
    ...mapActions("laboratory", ["countPackagesPending"]),
    selectItem(key) {
      this.selectedItemKey = key;
      this.drawer = false;
    },

    hasPermission(permission) {
      return this.permissions?.includes(permission);
    },

    setInitialItem() {
      this.selectedItemKey = this.availableMenuItems[0]?.key || null;
    },
    async fetchPendingPackages() {
      try {
        const response = await this.countPackagesPending();
        this.packagePendingQuantity = response.count;
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    permissions: {
      immediate: true,
      async handler() {
        if (!this.isSetup && this.permissions.length > 0) {
          this.isSetup = true;
          this.setInitialItem();
          await this.fetchPendingPackages();
        }
      },
    },
  },
  async mounted() {
    this.setInitialItem();
  },
};
</script>

<style scoped>
.admin-console {
  padding: 12px;
  height: 100%;
}

.admin-title {
  font-size: 1.25rem;
  font-weight: 500;
}

.main-content-card {
  height: calc(100% - 76px);
}

.content-col {
  padding: 16px;
  overflow-y: auto;
  max-height: 100%;
}

.content-wrapper {
  min-height: 100%;
}

.highlighted {
  background-color: rgba(4, 193, 5, 0.1);
}

.custom-icon {
  background: linear-gradient(45deg, #ff8f1c, #04c105);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.floating-menu {
  position: fixed;
  left: 16px;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 960px) {
  .admin-console {
    padding: 8px;
  }
  .main-content-card {
    height: calc(100% - 68px);
  }
  .content-col {
    padding: 8px;
  }
}

@media (max-width: 600px) {
  .admin-title {
    font-size: 1.1rem;
  }
  .v-list-item__title {
    font-size: 0.9rem;
  }
}
</style>
